import { observer } from 'mobx-react-lite'
import type { Stores } from '../../util/store'
import { useManufacturers } from '../../stores/manufacturers-store'
import { useCallback } from 'react'
import type { APICreateManufacturerRequest } from '@visorpro/client/dist/RestClient/services'
import { ManufacturersTable } from '../../components/manufacturers-table'

export interface ManufacturersPageProps {
    stores: Stores
}

export const ManufacturersPage = observer(
    ({ stores }: ManufacturersPageProps) => {
        const manufacturers = useManufacturers(stores)

        const createManufacturer = useCallback(
            async (options: APICreateManufacturerRequest) => {
                await stores.manufacturers.create(options)
            },
            [stores.manufacturers],
        )

        return (
            <div data-testid="manufacturers-page" style={{ display: 'contents' }}>
                <ManufacturersTable
                    manufacturers={manufacturers}
                    stores={stores}
                    isLoading={stores.manufacturers.isFetching}
                    showProgressBars={stores.manufacturers.isUpdating}
                    rowCount={stores.manufacturers.manufacturerIds.length}
                    isPrimaryBackgroundColor={true}
                    createManufacturer={createManufacturer}
                />
            </div>
        )
    },
)
